export const removeHtml = (html: string) => {
  // regex to remove html tags
  const regex = /(<([^>]+)>)/gi;
  return html.replace(regex, "");
};
